import React from "react";

const SocialProof = () => {
  // Testimonials section removed - will be added when real client testimonials are available

  return (
    <section className="py-20 relative overflow-hidden" style={{ background: 'var(--bg-section)' }}>
      <div className="container relative z-10">
        {/* Success imagery for visual reinforcement */}
        <div className="absolute top-0 right-0 opacity-20 hidden lg:block">
          <img 
            src="https://images.unsplash.com/photo-1600880292203-757bb62b4baf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHN1Y2Nlc3N8ZW58MHx8fHwxNzU5OTMzNzY4fDA&ixlib=rb-4.1.0&q=85" 
            alt="Business success celebration"
            className="w-80 h-60 object-cover rounded-lg"
          />
        </div>
        <div className="text-center mb-16">
          <h2 className="heading-1 mb-4">
            Proven AI Methodology Ready for Your Business
          </h2>
          <p className="body-large" style={{ 
            maxWidth: '600px', 
            margin: '0 auto',
            color: 'var(--text-secondary)' 
          }}>
            Our 6-agent AI system is built on industry best practices and proven automation frameworks. 
            We're ready to deliver professional AI implementation for forward-thinking businesses.
          </p>
        </div>

        {/* Client Success Focus - No Testimonials Yet */}
        <div className="text-center mb-16">
          <div className="inline-flex flex-col items-center gap-4 p-8 rounded-lg max-w-2xl mx-auto" style={{ background: 'var(--bg-card)' }}>
            <h3 className="heading-2 mb-4">
              Join Our Founding Clients
            </h3>
            <p className="body-medium mb-6" style={{ color: 'var(--text-secondary)' }}>
              We're launching our comprehensive AI agent system to help businesses automate their operations and scale efficiently. 
              Join our founding clients and get priority implementation with our satisfaction guarantee.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
              <div className="text-center p-4 rounded-lg" style={{ background: 'var(--accent-green-200)' }}>
                <div className="heading-3 mb-2">Founding Client</div>
                <div className="body-small">Priority Support</div>
              </div>
              <div className="text-center p-4 rounded-lg" style={{ background: 'var(--accent-blue-200)' }}>
                <div className="heading-3 mb-2">Satisfaction Guarantee</div>
                <div className="body-small">Quality Assured</div>
              </div>
              <div className="text-center p-4 rounded-lg" style={{ background: 'var(--accent-purple-200)' }}>
                <div className="heading-3 mb-2">30 Day Setup</div>
                <div className="body-small">Fast Implementation</div>
              </div>
            </div>
            <button className="btn-primary hover-scale">
              Schedule a Consultation
            </button>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <button className="btn-primary hover-scale">
            Get Started with AI Automation
          </button>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;